export default "__VITE_ASSET__B975xs99__"